import { render, staticRenderFns } from "./BaseDotIcon.vue?vue&type=template&id=92c55ae8"
import script from "./BaseDotIcon.vue?vue&type=script&lang=js"
export * from "./BaseDotIcon.vue?vue&type=script&lang=js"
import style0 from "./BaseDotIcon.vue?vue&type=style&index=0&id=92c55ae8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports